if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Error = Backbone.View.extend({
  show: function() {
    return this.$el.show();
  },
  hide: function() {
    return this.$el.hide();
  }
});

module.exports = VariationsWidget.Views.Error;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy92YXJpYXRpb25zL2Zyb250ZW5kL3ZpZXdzL2Vycm9yLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvdmFyaWF0aW9ucy9mcm9udGVuZC92aWV3cy9lcnJvci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtFQUFBLE1BQU0sQ0FBQyxtQkFBb0I7Ozs7RUFDM0IsZ0JBQWdCLENBQUMsUUFBUzs7O0FBRTFCLGdCQUFnQixDQUFDLEtBQUssQ0FBQyxLQUF2QixHQUErQixRQUFRLENBQUMsSUFBSSxDQUFDLE1BQWQsQ0FDN0I7RUFBQSxJQUFBLEVBQU0sU0FBQTtXQUFHLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFBO0VBQUgsQ0FBTjtFQUNBLElBQUEsRUFBTSxTQUFBO1dBQUcsSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQUE7RUFBSCxDQUROO0NBRDZCOztBQUsvQixNQUFNLENBQUMsT0FBUCxHQUFpQixnQkFBZ0IsQ0FBQyxLQUFLLENBQUMifQ==
